import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  container: {
    padding: 0,
    width: "100%",
  },
}));
